import withTheme from '@material-ui/core/styles/withTheme';

import Drawer from '~/components/SidebarDrawer';

import ListResponses from './responses/ListResponses';
import ShowResponse from './responses/ShowResponse';

class Responses extends React.Component {
  constructor(props) {
    super(props);
    this.state = { response: null };
  }

  showResponse(response) {
    this.setState({ response: response });
  }

  closeDrawer = () => {
    this.setState({ response: null });
  };

  render() {
    const { response } = this.state;
    const { form, theme, columns, deleteResponse } = this.props;

    return (
      <div style={theme.flexStretch}>
        <ListResponses
          form={form}
          columns={columns}
          onShowResponse={this.showResponse.bind(this)}
        />

        <Drawer open={!!response} onClose={() => this.closeDrawer()}>
          {response && (
            <ShowResponse
              closeDrawer={this.closeDrawer}
              deleteResponse={deleteResponse}
              response={response}
            />
          )}
        </Drawer>
      </div>
    );
  }
}

Responses.propTypes = {
  form: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  deleteResponse: PropTypes.func.isRequired,
};

export default withTheme()(Responses);
